import Icon from '../components/Icon.vue'

Icon.register({
  'file-upload': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M224 136c0 13.2 10.8 24 24 24h136v328c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-464c0-13.3 10.7-24 24-24h200v136zM289.2 352c14.3 0 21.4-17.3 11.3-27.4l-96.4-95.7c-6.6-6.6-17.4-6.6-24 0l-96.4 95.7c-10.1 10.1-3 27.4 11.3 27.4h65.2v80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-80h65.2zM377 105c4.5 4.5 7 10.6 7 16.9v6.1h-128v-128h6.1c6.4 0 12.5 2.5 17 7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-upload.js
// module id = 1343
// module chunks = 0